document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('EliteActivateForm');
  if (!form) return;

  const successEl = document.querySelector('.violex-elite-activate__success');
  const errorEl = document.querySelector('.violex-elite-activate__error');
  const defaultErrorText = errorEl ? errorEl.textContent : '';
  // Eigene Meldung fuer UNSERE Probleme (Endpoint nicht konfiguriert, Netzwerk-
  // fehler) - bewusst getrennt von defaultErrorText (code-spezifisch, siehe
  // redeem.js: "invalid or already used" ist absichtlich generisch gehalten,
  // damit niemand per Trial-and-Error freie von benutzten Codes unterscheiden
  // kann). Ein technisches Problem soll nie wie "dein Code ist falsch" aussehen.
  const technicalErrorText = form.dataset.technicalErrorText || defaultErrorText;
  const endpoint = form.dataset.redeemEndpoint;

  const codeInput = document.getElementById('EliteActivateCode');
  const params = new URLSearchParams(window.location.search);
  const urlCode = params.get('code');
  if (urlCode && !codeInput.value) codeInput.value = urlCode;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (errorEl) errorEl.hidden = true;

    if (!endpoint) {
      if (errorEl) {
        errorEl.textContent = technicalErrorText;
        errorEl.hidden = false;
      }
      return;
    }

    const submitBtn = form.querySelector('.violex-elite-activate__submit');
    submitBtn.disabled = true;

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          code: codeInput.value.trim(),
          name: form.elements.name.value.trim(),
          email: form.elements.email.value.trim(),
        }),
      });
      const data = await res.json();

      if (res.ok && data.ok) {
        form.hidden = true;
        if (successEl) successEl.hidden = false;
      } else if (errorEl) {
        errorEl.textContent = data.message || defaultErrorText;
        errorEl.hidden = false;
      }
    } catch (_networkError) {
      if (errorEl) {
        errorEl.textContent = technicalErrorText;
        errorEl.hidden = false;
      }
    } finally {
      submitBtn.disabled = false;
    }
  });
});
